<template>
  <div>
    <div ref="target">
      <SpinnerButton
        type="button"
        class="tw-rounded-full"
        :disabled="disabled"
        v-bind="$attrs"
        @click="$emit('click')"
      >
        {{ buttonText }}
      </SpinnerButton>
    </div>

    <div ref="content">
      <slot />
    </div>
  </div>
</template>

<script>
import tippy from 'tippy.js'
import SpinnerButton from '@/components/SpinnerButton'

export default {
  name: 'SpinnerButtonWithTooltip',

  components: {
    SpinnerButton,
  },

  props: {
    disabled: {
      type: Boolean,
      default: true,
    },

    buttonText: {
      type: String,
      default: '',
    },
  },

  watch: {
    disabled() {
      if (!this.tippy) return

      if (this.disabled) {
        this.tippy.enable()
      } else {
        this.tippy.disable()
      }
    },
  },

  mounted() {
    const content = this.$refs.content.firstChild

    if (content) {
      this.tippy = tippy.one(this.$refs.target, {
        html: content,
        placement: 'right',
        distance: 1,
        interactiveBorder: 15,
        interactive: true,
        theme: 'dark',
        arrow: true,
        delay: [400, 0],
        width: '10px',
      })

      if (!this.disabled) {
        this.tippy.disable()
      }
    }

    this.$once('hook:beforeDestroy', () => {
      if (this.tippy) {
        this.tippy.destroy()
      }
    })
  },
}
</script>
